import $ from 'jquery';

$(function () {
    let $blocks = $('.page-blocks .block');

    if ($blocks.length) {
        let $halfWidthBlocks = $blocks.filter('.width-half');

        for (let i = 0; i < $halfWidthBlocks.length; i++) {
            let $block = $($halfWidthBlocks[i]);
            let xOffsets = {
                left: $block.offset().left,
                right: $(window).width() - ($block.offset().left + $block.outerWidth(true))
            };

            if (xOffsets.left == 0) {
                $block.addClass('side-left');
            } else if (xOffsets.right == 0) {
                $block.addClass('side-right');
            }
        }
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/components/BlockPositionIdentifier.js